import React, { useState } from "react";
import { X } from "lucide-react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Spinner } from "reactstrap";

import * as api from "services/api";

import StyledModal from "components/StyledModal";

import { ButtonsContainer, ModalBody, ModalHeader, Separator } from "./styles";

export function DeleteDocumentModal({
	isModalOpen,
	setIsModalOpen,
	documentId,
	documentName,
	onDocumentDeleted
}) {
	const [isLoading, setIsLoading] = useState(false);

	const { token } = useSelector(s => s.login);

	async function handleDocumentDelete() {
		try {
			setIsLoading(true);

			const response = await api.sendDelete(
				`/contract-solicitation-document/${documentId}`,
				{
					Authorization: "Bearer " + token
				}
			);

			const result = await response.json();

			if (result.isValid) {
				toast.success("Documento deletado com sucesso.");
				setIsModalOpen(false);
				onDocumentDeleted && onDocumentDeleted();
			} else {
				toast.error(
					"Houve um erro ao deletar o documento. Tente novamente mais tarde."
				);
			}
		} catch (error) {
			toast.error(
				"Houve um erro ao deletar o documento. Tente novamente mais tarde."
			);
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	}

	return (
		<StyledModal open={isModalOpen} handleClose={() => setIsModalOpen(false)}>
			<ModalHeader>
				<p>Confirme esta ação</p>
				<button onClick={() => setIsModalOpen(false)}>
					<X size={24} color="#8e8e93" />
				</button>
			</ModalHeader>

			<Separator />

			<ModalBody>
				<h1>Deseja excluir esse documento?</h1>

				<p>{documentName}</p>
			</ModalBody>

			<ButtonsContainer>
				<button onClick={() => setIsModalOpen(false)} disabled={isLoading}>
					Cancelar
				</button>
				<button onClick={handleDocumentDelete} disabled={isLoading}>
					{isLoading ? <Spinner size="sm" /> : "Confirmar"}
				</button>
			</ButtonsContainer>
		</StyledModal>
	);
}
